// extracted by mini-css-extract-plugin
export default {"table":"Analytics_table__ECPvb","btn":"Analytics_btn__z0yGj","activeBtn":"Analytics_activeBtn__SbGnd"};